import React from 'react'
import { RouteProps, Route, Switch, Redirect } from 'react-router-dom'
import Loading from '@/components/loading'
import NotFound from '@/components/notFound'

const { lazy, Suspense } = React

const Demo = lazy(() => import(/* webpackChunkName:"demo" */ '@/pages/demos'))

// 验证步骤
const VerifySteps = lazy(() =>
  import(/* webpackChunkName:"verifySteps" */ '@/pages/verifySteps')
)
const VerifyMobile = lazy(() =>
  import(/* webpackChunkName:"verifyMobile" */ '@/pages/verifySteps/mobile')
)
const VerifyIdentity = lazy(() =>
  import(/* webpackChunkName:"verifyMobile" */ '@/pages/verifySteps/identity')
)
const VerifyBusiness = lazy(() =>
  import(/* webpackChunkName:"verifyBusiness" */ '@/pages/verifySteps/business')
)
const VerifyAgree = lazy(() =>
  import(/* webpackChunkName:"verifyMobile" */ '@/pages/verifySteps/agreement')
)
const VerifyNoPass = lazy(() =>
  import(/* webpackChunkName:"verifyMobile" */ '@/pages/verifySteps/nopass')
)
const VerifySuccess = lazy(() =>
  import(/* webpackChunkName:"verifyMobile" */ '@/pages/verifySteps/success')
)

//员工管理
const EmpManage = lazy(() =>
  import(/* webpackChunkName:"empManage" */ '@/pages/emp-manage/emp-manage')
)
const EmpDetail = lazy(() =>
  import(/* webpackChunkName:"empDetail" */ '@/pages/emp-manage/emp-detail')
)
const EmpEdit = lazy(() =>
  import(/* webpackChunkName:"empEdit" */ '@/pages/emp-manage/emp-edit')
)

/**
 * 用户已登录的路由
 * `请尽量保持一级路由结构，以便维护`
 */
const routes: RouteProps[] = [
  {
    path: '/admin/verifySteps',
    component: VerifySteps
  },
  {
    path: '/admin/verifySteps/mobile',
    component: VerifyMobile
  },
  {
    path: '/admin/verifySteps/identity',
    component: VerifyIdentity
  },
  {
    path: '/admin/verifySteps/business',
    component: VerifyBusiness
  },
  {
    path: '/admin/verifySteps/agreement',
    component: VerifyAgree
  },
  {
    path: '/admin/verifySteps/fail',
    component: VerifyNoPass
  },
  {
    path: '/admin/verifySteps/success',
    component: VerifySuccess
  },
  {
    path: '/admin/empManage',
    component: EmpManage
  },
  // {
  //   path: '/admin/empManage/detail/:staffId/:operate',
  //   component: EmpDetail
  // },
  {
    path: '/admin/empManage/detail',
    component: EmpDetail
  },
  {
    path: '/admin/empManage/edit',
    component: EmpEdit
  }
]

if (!$PROD) {
  routes.push({
    path: '/admin/demos',
    component: Demo
  })
}

routes.push({
  path: '*',
  component: NotFound
})

export const AdminRoutes = (authorized: boolean) => (
  <Suspense fallback={<Loading />}>
    <Switch>
      {routes.map(r => {
        const { path, exact, component: LazyCom } = r
        if (!LazyCom) return null
        return (
          <Route
            key={path + ''}
            exact={exact !== false}
            path={path}
            render={props =>
              authorized ? <LazyCom {...props} /> : <Redirect to="/login" />
            }
          />
        )
      })}
    </Switch>
  </Suspense>
)
